export const FIN_YEAR_REQUEST = 'FIN_YEAR_REQUEST';
export const GET_FIN_YEARS = 'GET_FIN_YEARS';
export const FIN_YEAR_FAILURE = 'FIN_YEAR_FAILURE';
export const CREATE_FIN_YEAR = 'CREATE_FIN_YEAR';
export const UPDATE_FIN_YEAR= 'UPDATE_FIN_YEAR';
export const DELETE_FIN_YEAR = 'DELETE_FIN_YEAR';